var map = {
	"./bfs/app/item-page/media-viewer/media-viewer.component": [
		8079,
		"src_themes_bfs_app_item-page_media-viewer_media-viewer_component_ts"
	],
	"./custom/app/item-page/media-viewer/media-viewer.component": [
		81917,
		"src_themes_custom_app_item-page_media-viewer_media-viewer_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5452;
module.exports = webpackAsyncContext;